import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import * as Redux from 'react-redux';

const NotasDefGraficoBarComponent = () => {
  const boletinesStore = Redux.useSelector((state) => state.boletines);

  const categories = boletinesStore.boletin.map((el) => el.nombre);
  const seriesData = boletinesStore.boletin.map((el) => el.definitiva);
  const colors = seriesData.map((nota) => {
    if (nota >= 16) {
      return 'green'; // Verde para calificaciones de 16 en adelante
    } else if (nota >= 10) {
      return 'orange'; // Naranja para calificaciones de 10 a 15
    } else {
      return 'red'; // Rojo para calificaciones menos de 10
    }
  });

  Highcharts.setOptions({
    colors: colors,
  });

  const options = {
    chart: {
      type: 'bar',
    },
    title: {
      text: 'Definitivas',
    },
    xAxis: {
      categories: categories,
      labels: {
        formatter: function () {
          // Ajusta el número de caracteres máximos que deseas mostrar
          const maxLength = 15;
          const label = this.value;
          return label.length > maxLength
            ? label.slice(0, maxLength - 10) + '...'
            : label;
        },
      },
    },
    yAxis: {
      title: {
        text: 'Calificación',
      },
    },
    series: [
      {
        name: 'Calificación',
        data: seriesData,
        colorByPoint: true, // Habilita la asignación de colores por punto
        colors: colors, //
        dataLabels: {
          enabled: true, // Habilita las etiquetas de datos
          format: '{y}', // Define el formato de las etiquetas (en este caso, simplemente mostrará el valor y)
          style: {
            fontWeight: 'bold',
          },
        },
      },
    ],
    tooltip: {
      pointFormat: 'Calificación: <b>{point.y}</b>',
    },
    //   plotOptions: {
    //     series: {
    //       cursor: 'pointer',
    //       point: {
    //         events: {
    //           legendItemClick: function () {
    //             return true; // Evita que los elementos de la leyenda se oculten al hacer clic en ellos
    //           }
    //         }
    //       }
    //     }
    //   }
    plotOptions: {
      // bar: {
      //   marker: {
      //     enabled: false // Deshabilita los marcadores (puntos grises)
      //   }
      // }
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default NotasDefGraficoBarComponent;
